import React, { useState } from 'react';
import CancelLogin from './CancelLogin'; // Adjust the import path as needed
import { initialiseDecoupledFlow } from '../actions';
import { postMessageSuccess } from '../helpers/postMessage';

/*function RevocationInfo({ revocationInfo }) {
  return (
    <p>
      {revocationInfo.text}{' '}
      <a href={process.env.REACT_APP_BANKSTATEMENTS_URL + '/' + revocationInfo.link.href} target={revocationInfo.link.target} rel="noopener noreferrer">
        {revocationInfo.link.label}
      </a>
    </p>
  );
}*/


const Consent = (props) => {
    const [openSections, setOpenSections] = useState({});
    const [isDeidentified, setIsDeidentified] = useState(false);

    const consentData = JSON.parse(props.consentData);

    const toggleSection = (key) => {
        setOpenSections((prev) => ({
            ...prev,
            [key]: !prev[key],
        }));
    };

    const onCancel = () => {
        const slug = props.slug;
        props.dispatch(postMessageSuccess("data_consent_illion", {data: slug}, "cancelled"));
        props.dispatch({ type: 'LOGIN_PROCESS_CANCELLED' });
    }

    const onSubmit = (e) => {
        e.preventDefault();
        const slug = props.slug;
        props.dispatch(postMessageSuccess("data_consent_illion", {
            data: slug,
            is_deidentified: isDeidentified,
        }));
        props.dispatch(initialiseDecoupledFlow(slug, isDeidentified))
    };

    let backToSelectionBtnText = props.theme.text.backToSelectionBtn;
    let requireWinz = false;
    

    return (
        <div className="step-content">
            <div id="intro">
                <div className="consent-data-wrapper">
                    <div className="formMain">
                        {consentData.title && <h2>{consentData.title}</h2>}
                        {consentData.description && <p dangerouslySetInnerHTML={{ __html: consentData.description }}></p>}

                        {Array.isArray(consentData.keyDetails) && consentData.keyDetails.length > 0 && (
                            <div className="consent-key-details">
                                <h5><strong>Key details</strong></h5>
                                {consentData.keyDetails.map((keyDetail, keyDetailIndex) => keyDetail && (
                                    <React.Fragment key={keyDetailIndex}>
                                        {keyDetail.title && <h6><strong>{keyDetail.title}</strong></h6>}
                                        {keyDetail.description && <p style={{ marginBottom: '15px' }} dangerouslySetInnerHTML={{ __html: keyDetail.description }}></p>}
                                    </React.Fragment>
                                ))}
                            </div>
                        )}

                        {consentData.whyAskedForData &&
                            (consentData.whyAskedForData.title || consentData.whyAskedForData.description) && (
                            <div className="why-asked-section">
                                {consentData.whyAskedForData.title && <h6><strong>{consentData.whyAskedForData.title}</strong></h6>}
                                {consentData.whyAskedForData.description && <p style={{ marginBottom: '15px' }} dangerouslySetInnerHTML={{ __html: consentData.whyAskedForData.description }}></p>}
                            </div>
                        )}                        

                        {Array.isArray(consentData.sections) && consentData.sections.length > 0 && consentData.sections.map((section, sectionIndex) => (
                            <React.Fragment key={sectionIndex}>
                                {section.title && <h6><strong>{section.title}</strong></h6>}
                                <div className="consent-type-section">
                                {Array.isArray(section.subSections) && section.subSections.map((sub, subIndex) => {
                                    const key = `${sectionIndex}-${subIndex}`;
                                    return (
                                        <div className="section" key={key}>
                                            <button
                                                className="toggle-btn"
                                                onClick={() => toggleSection(key)}
                                            >
                                                {sub.title && <span>{sub.title}</span>}
                                                <span className={`arrow ${openSections[key] ? 'rotate' : ''}`}>
                                                    ▶
                                                </span>
                                            </button>
                                            {openSections[key] && (
                                                <div className="toggle-content">
                                                    {sub.description && <p dangerouslySetInnerHTML={{ __html: sub.description }}></p>}
                                                </div>
                                            )}
                                        </div>
                                    );
                                })}
                                </div>
                            </React.Fragment>
                        ))}

                        {consentData.accessUpTo && (
                            <div className="access-upto-section">
                                {consentData.accessUpTo && <p style={{ marginBottom: '15px' }} dangerouslySetInnerHTML={{ __html: consentData.accessUpTo }}></p>}
                            </div>
                        )}                        

                        {consentData.accessExpiry &&
                            (consentData.accessExpiry.title || consentData.accessExpiry.description) && (
                            <div className="access-expiry">
                                {consentData.accessExpiry.title && <h6><strong>{consentData.accessExpiry.title}</strong></h6>}
                                {consentData.accessExpiry.description && <p style={{ marginBottom: '15px' }} dangerouslySetInnerHTML={{ __html: consentData.accessExpiry.description }}></p>}
                            </div>
                        )}

                        {consentData.howExperianUseData &&
                            (consentData.howExperianUseData.title || consentData.howExperianUseData.description) && (
                            <div className="how-experian-use-section">
                                {consentData.howExperianUseData.title && <h6><strong>{consentData.howExperianUseData.title}</strong></h6>}
                                {consentData.howExperianUseData.description && <p style={{ marginBottom: '15px' }} dangerouslySetInnerHTML={{ __html: consentData.howExperianUseData.description }}></p>}
                            </div>
                        )}

                        {consentData.deIdentification &&
                            (consentData.deIdentification.title || consentData.deIdentification.description) && (
                            <div className="de-identification-section">
                                {consentData.deIdentification.title && <h6><strong>{consentData.deIdentification.title}</strong></h6>}
                                {consentData.deIdentification.description && (
                                    <p style={{ marginBottom: '15px' }}>
                                        <input
                                            type="checkbox"
                                            name="is_deidentified"
                                            checked={isDeidentified}
                                            onChange={(event) => setIsDeidentified(event.target.checked)}
                                        />{' '}
                                        <span dangerouslySetInnerHTML={{ __html: consentData.deIdentification.description }}></span>
                                    </p>
                                )}
                            </div>
                        )}

                        {consentData.consentManagement &&
                            (consentData.consentManagement.title || consentData.consentManagement.description) && (
                            <div className="consent-management-section">
                                {consentData.consentManagement.title && <h6><strong>{consentData.consentManagement.title}</strong></h6>}
                                {consentData.consentManagement.description && <p style={{ marginBottom: '15px' }} dangerouslySetInnerHTML={{ __html: consentData.consentManagement.description }}></p>}
                            </div>
                        )}

                        {consentData.finalConsentPrompt && <h6><strong>{consentData.finalConsentPrompt}</strong></h6>}
                        {consentData.acceptanceNote && <p>{consentData.acceptanceNote}</p>}
                    </div>

                    <div className="form-group">
                        <button
                            type="submit"
                            title="I Consent"
                            className="form-control btn btn-primary"
                            onClick={onSubmit}
                        >
                            I Consent
                        </button>
                    </div>
                    <CancelLogin
                        action={onCancel}
                        theme={props.theme}
                        backToSelectionBtnText={backToSelectionBtnText}
                        requireWinz={requireWinz}
                    />
                </div>
            </div>
        </div>
    );
};

export default Consent;
